import { CREATE_INFRA_ZONE,ZONE_LIST } from "./type";

const initalState = {
    infraZoneRes: null,
    zoneList: {}
};

const CreateInfraZoneReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CREATE_INFRA_ZONE:
            return {
                ...state,
                infraZoneRes: payload,
            };
        case ZONE_LIST:
            return {
                ...state,
                zoneList: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default CreateInfraZoneReducer;
